import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function ServiceCard({ service, index = 0 }) {
  return (
    <motion.div
      style={{ height: '100%' }}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-40px' }}
      transition={{ duration: 0.5, delay: (index % 3) * 0.08 }}
    >
      <Link to={`/services/${service.slug || service._id}`} className="scard">
        <div className="scard__icon">{service.icon || '✨'}</div>
        <h3 className="scard__title">{service.title}</h3>
        <p className="scard__desc clamp-3">{service.shortDescription}</p>
        {service.tags?.length > 0 && (
          <div className="flex gap wrap" style={{ marginBottom: 14 }}>
            {service.tags.slice(0, 3).map((t, i) => (
              <span key={i} className="tag-chip">#{t}</span>
            ))}
          </div>
        )}
        <span className="scard__link">Learn more →</span>
      </Link>
    </motion.div>
  );
}
